export default __webpack_public_path__ + "static/media/Rotary Tiller.c330a312.png";